import React, { useState, Fragment } from 'react';
import { IntakeForm } from './components/IntakeForm';
import { Questionnaire } from './components/Questionnaire';
import { Results } from './components/Results';
import { Header } from './components/Header';
export function App() {
  const [step, setStep] = useState(1);
  const [clientData, setClientData] = useState({
    fullName: '',
    email: '',
    mobile: '',
    website: '',
    challenge: '',
    target: '',
    companyProfile: null
  });
  const [auditResponses, setAuditResponses] = useState({
    sales: {},
    marketing: {},
    operations: {},
    hr: {},
    finance: {}
  });
  const handleClientDataSubmit = data => {
    setClientData(data);
    setStep(2);
  };
  const handleQuestionnaireSubmit = responses => {
    setAuditResponses(responses);
    setStep(3);
  };
  const handleRestart = () => {
    setClientData({
      fullName: '',
      email: '',
      mobile: '',
      website: '',
      challenge: '',
      target: '',
      companyProfile: null
    });
    setAuditResponses({
      sales: {},
      marketing: {},
      operations: {},
      hr: {},
      finance: {}
    });
    setStep(1);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      <Header data-id="element-1" />
      <div className="container mx-auto px-4 py-8" data-id="element-2">
        <div className="mb-8" data-id="element-3">
          <div className="flex justify-center mb-6" data-id="element-4">
            <div className="w-full max-w-3xl flex items-center" data-id="element-5">
              {[1, 2, 3].map(stepNumber => <Fragment key={stepNumber} data-id="element-6">
                  <div className={`flex-1 flex flex-col items-center ${step === stepNumber ? 'opacity-100' : 'opacity-60'}`} data-id="element-7">
                    <div className={`w-10 h-10 flex items-center justify-center rounded-full ${step >= stepNumber ? 'bg-blue-600' : 'bg-gray-300'} text-white font-semibold`} data-id="element-8">
                      {stepNumber}
                    </div>
                    <div className="mt-2 text-sm font-medium text-gray-700" data-id="element-9">
                      {stepNumber === 1 && 'Business Information'}
                      {stepNumber === 2 && 'Self-Assessment'}
                      {stepNumber === 3 && 'Results & Insights'}
                    </div>
                  </div>
                  {stepNumber < 3 && <div className={`flex-1 h-1 ${step > stepNumber ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-10"></div>}
                </Fragment>)}
            </div>
          </div>
        </div>
        <main className="bg-white rounded-lg shadow-md p-6 md:p-8 max-w-5xl mx-auto" data-id="element-11">
          {step === 1 && <IntakeForm onSubmit={handleClientDataSubmit} data-id="element-12" />}
          {step === 2 && <Questionnaire clientData={clientData} onSubmit={handleQuestionnaireSubmit} data-id="element-13" />}
          {step === 3 && <Results clientData={clientData} auditResponses={auditResponses} onRestart={handleRestart} data-id="element-14" />}
        </main>
      </div>
    </div>;
}